/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.15.0
 */
import { EOnboardingComponentsId, EOnboardingModalId, EOnboardingPage } from './types/onboardingTypes';

export interface IOnboardingModalResponse {
    modalId: number;
}

export interface IOnboardingStatusResponse {
    isDisabledByUser: boolean;
    isOnboardingExists: boolean; // Страница имеет элементы с онбордингом
    isWelcomeOnboardingCompleted: boolean; // Welcome-онбординг по странице пройден пользователем
    isWelcomeOnboardingExists: boolean; // Страница имеет элементы welcome-онбординга
    unviewedElementsIds: number[]; // Список непросмотренных элементов
}

export const mapOnboardingElementId: { [key: number]: EOnboardingComponentsId } = {
    // главная страница
    11: EOnboardingComponentsId.widgetCost,
    12: EOnboardingComponentsId.widgetPersonalAccount,
    13: EOnboardingComponentsId.linkAccounts,
    14: EOnboardingComponentsId.linkSubscribers,
    15: EOnboardingComponentsId.linkProducts,
    16: EOnboardingComponentsId.notificationsMenu,
    17: EOnboardingComponentsId.linkHistoryAndOrders,
    18: EOnboardingComponentsId.fastActionsPlate,
    // список ЛС
    21: EOnboardingComponentsId.accountsTableSettings,
    22: EOnboardingComponentsId.accountsTableFooterButtonBills,
    23: EOnboardingComponentsId.accountsTableFooterButtonDcRules,
    24: EOnboardingComponentsId.accountsTableFooterButtonReconciliation,
    25: EOnboardingComponentsId.accountsTableFooterButtonExpenses,
    26: EOnboardingComponentsId.accountsTableFooterButtonReports,
    // Анализатор ЛС
    31: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonWizardExpensesDetail,
    32: EOnboardingComponentsId.expensesAnalyzerAccountChart,
    33: EOnboardingComponentsId.expensesAnalyzerAccountTable,
    34: EOnboardingComponentsId.expensesAnalyzerAccountChartTab,
    35: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonShowSubsExpenses,
    36: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonShowDailyExpenses,
    37: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonCallDetails,
    // список МС
    41: EOnboardingComponentsId.subscriberTablePersonalImport,
    42: EOnboardingComponentsId.subscriberTableSettings,
    43: EOnboardingComponentsId.subscriberTableFooterButtonManageBlock,
    44: EOnboardingComponentsId.subscriberTableFooterButtonTariffChange,
    45: EOnboardingComponentsId.subscriberTableFooterButtonCallDetails,
    46: EOnboardingComponentsId.subscriberTableFooterButtonExpenses,
    47: EOnboardingComponentsId.subscribersInRoaming,
    // Тарифы и услуги
    51: EOnboardingComponentsId.productCardList,
    52: EOnboardingComponentsId.productCategories,
    53: EOnboardingComponentsId.productFilterRegion,
    54: EOnboardingComponentsId.productTabSelected,
    55: EOnboardingComponentsId.productCardMooreDetailsLink,
    56: EOnboardingComponentsId.productBtnConnect,
    // Настройки
    61: EOnboardingComponentsId.settingsTabProfile,
    62: EOnboardingComponentsId.settingsTabLabels,
    63: EOnboardingComponentsId.settingsTabPositions,
    64: EOnboardingComponentsId.settingsTabNotifications,
    // Счета
    71: EOnboardingComponentsId.billsTable,
    72: EOnboardingComponentsId.billsDescription,
    73: EOnboardingComponentsId.billsTableFooterButtonBillsDoc,
    74: EOnboardingComponentsId.billsTableFooterButtonCompare,
    75: EOnboardingComponentsId.billsTableFooterButtonReconciliation,
    // Обращения
    76: EOnboardingComponentsId.inquiriesTabMenu,
};

export const mapOnboardingModalId: { [key: number]: EOnboardingModalId } = {
    1001: EOnboardingModalId.modalWelcome,
};

export const mapOnboardingPages: { [key in EOnboardingPage]: number } = {
    [EOnboardingPage.dashboard]: 1,
    [EOnboardingPage.accounts]: 2,
    [EOnboardingPage.expensesAnalyzerAccount]: 3,
    [EOnboardingPage.subscriberMobile]: 4,
    [EOnboardingPage.products]: 5,
    [EOnboardingPage.settings]: 6,
    [EOnboardingPage.bills]: 7,
    [EOnboardingPage.inquiries]: 8,
};
